import { createReducer } from "@reduxjs/toolkit";
import {
    InitialState,
} from "./types";
import { reducerHelper } from '../reducerHelper'
import {
    driverSalaryAdjustmentsDetail,
    driverSalaryAdjustmentsCreate,
    driverSalaryAdjustmentsDelete,
    driverSalaryAdjustmentsEdit,
    driverSalaryAdjustmentsDetailCreate,
    driverSalaryAdjustmentsDetailDelete,
    driverSalaryAdjustmentsDetailEdit,
    driverSalaryAdjustmentsInfo,
    driverSalaryAdjustmentsDetailList,
    driverSalaryAdjustmentsDetailOne
} from "./actions";

const initialState: InitialState = {
    detail: {
        data: null,
        loading: false,
        error: null,
    },
    delete: {
        loading: false,
        error: null, 
    },
    create: {
        loading: false,
        error: null, 
    },
    edit: {
        loading: false,
        error: null,    
    },
    detailInfo: {
        data: null,
        loading: false,
        error: null,
    },
    //detail
    createDetail: {
        loading: false,
        error: null, 
    },
    deleteDetail: {
        loading: false,
        error: null,
    },

    editDetail: {
        loading: false,
        error: null,
    },
    detailList: {
        data: [],
        loading: false,
        error: null,
    },
    detailOne: {
        data: null,
        loading: false,
        error: null,
    },
}

export const driverSalaryAdjustmentsReducer = createReducer(initialState, (builder) => {
    reducerHelper<InitialState>(builder, driverSalaryAdjustmentsDetail, 'detail', null);
    reducerHelper<InitialState>(builder, driverSalaryAdjustmentsDelete, 'delete', null);
    reducerHelper<InitialState>(builder, driverSalaryAdjustmentsCreate, 'create', null);
    reducerHelper<InitialState>(builder, driverSalaryAdjustmentsEdit, 'edit', null);
    reducerHelper<InitialState>(builder, driverSalaryAdjustmentsInfo, 'detailInfo', null);
    //detail
    reducerHelper<InitialState>(builder, driverSalaryAdjustmentsDetailOne, 'detailOne', null);
    reducerHelper<InitialState>(builder, driverSalaryAdjustmentsDetailList, 'detailList', []);
    reducerHelper<InitialState>(builder, driverSalaryAdjustmentsDetailCreate, 'createDetail', null);
    reducerHelper<InitialState>(builder, driverSalaryAdjustmentsDetailDelete, 'deleteDetail', null);
    reducerHelper<InitialState>(builder, driverSalaryAdjustmentsDetailEdit, 'editDetail', null);
})
